/**
 * The backend refuses an anonymous CV upload with HTTP 409 when the CV's email already belongs to
 * a candidate (PortalResource.importResume -> PortalUploadService). The message is a code:
 *   EMAIL_EXISTS       the candidate has a portal login -> send them to sign in
 *   VERIFICATION_SENT  the candidate had no login; a "verify your account" email was sent
 * Returns the login-page navigation for either, or null when the error is something else.
 */
export const UPLOAD_EMAIL_EXISTS = 'EMAIL_EXISTS';
export const UPLOAD_VERIFICATION_SENT = 'VERIFICATION_SENT';

export function uploadConflictRoute(err: any): any[] | null {
  if (!err || err.status !== 409) {
    return null;
  }
  const code = (err.error && err.error.message) || '';
  if (code === UPLOAD_EMAIL_EXISTS) {
    return ['/login', { alreadyExists: true }];
  }
  if (code === UPLOAD_VERIFICATION_SENT) {
    return ['/login', { verificationSent: true }];
  }
  return null;
}
